import styled from 'styled-components';

export const List = styled.ul`
  width: 100%;
`;
